import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AUTH } from "@/constants/testIds";

export default function RegisterPage() {
  const { register, formatErr } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name:"", email:"", password:"", phone:"", role:"citizen" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await register(form);
      nav("/app");
    } catch (e) {
      setError(formatErr(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden hero-punjab text-white">
        <div className="absolute inset-0 grain pointer-events-none"/>
        <div className="relative p-12 flex flex-col h-full">
          <Link to="/" className="flex items-center gap-2">
            <div className="grid place-items-center h-10 w-10 rounded-lg bg-[hsl(var(--primary))] text-white font-bold text-[10px]">PEDA</div>
            <div className="font-heading font-semibold text-sm">PEDA Portal</div>
          </Link>
          <div className="mt-auto">
            <h1 className="text-4xl font-heading font-bold">Create your account</h1>
            <p className="mt-3 max-w-md text-white/80">Apply for schemes, track applications, and access every PEDA service — with just one login.</p>
          </div>
        </div>
      </div>
      <div className="grid place-items-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <h2 className="text-3xl font-heading font-bold">Register</h2>
          <p className="text-muted-foreground mt-1 text-sm">Citizen · Industry · Farmer · Vendor · Consultant</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs font-semibold text-muted-foreground">Full name</label>
              <input data-testid={AUTH.registerName} required value={form.name} onChange={change("name")} className="input mt-1"/>
            </div>
            <div>
              <label className="text-xs font-semibold text-muted-foreground">Email</label>
              <input data-testid={AUTH.registerEmail} required type="email" value={form.email} onChange={change("email")} className="input mt-1"/>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-xs font-semibold text-muted-foreground">Phone</label>
                <input value={form.phone} onChange={change("phone")} className="input mt-1"/>
              </div>
              <div>
                <label className="text-xs font-semibold text-muted-foreground">Role</label>
                <select value={form.role} onChange={change("role")} className="input mt-1">
                  <option value="citizen">Citizen</option>
                  <option value="industry">Industry</option>
                  <option value="farmer">Farmer</option>
                  <option value="vendor">Vendor</option>
                  <option value="consultant">Consultant</option>
                </select>
              </div>
            </div>
            <div>
              <label className="text-xs font-semibold text-muted-foreground">Password</label>
              <input data-testid={AUTH.registerPassword} required minLength={6} type="password" value={form.password} onChange={change("password")} className="input mt-1"/>
            </div>
            {error && <div className="text-red-500 text-sm">{error}</div>}
            <button data-testid={AUTH.registerSubmit} disabled={loading} type="submit" className="btn-primary w-full justify-center">
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>
          <div className="mt-6 text-sm text-center text-muted-foreground">
            Already have an account? <Link to="/login" className="text-[hsl(var(--primary))] font-semibold">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
